import { FC, useEffect, useState } from 'react';
import { IUserOrgId, useAuth } from 'obt-common';
import { useTranslation } from 'react-i18next';
import { Button } from '@spotnana/blocks/src/Button';
import { paddings } from '@spotnana/blocks/src/utils/styling/utilityTokens';
import CreateCard from '../../../v1-components/profile/info/Payment/CreateCard';

interface AddCardOptionProps {
  userOrgId: IUserOrgId;
  onCardCreate: () => void;
  cardCount: number;
  onPaymentAddNewCardClick?: VoidFunction;
}

const AddCardOption: FC<AddCardOptionProps> = ({ userOrgId, onCardCreate, cardCount, onPaymentAddNewCardClick }) => {
  const { t: tt } = useTranslation('WEB');
  const [showCreateCardModal, setShowCreateCardModal] = useState(false);
  const [authToken, setAuthToken] = useState<string>('');
  const { getAuthToken } = useAuth();

  const handleCreateCardModalOpen = () => {
    onPaymentAddNewCardClick?.();
    setShowCreateCardModal(true);
  };

  const handleCreateCardModalClose = () => {
    setShowCreateCardModal(false);
  };

  useEffect(() => {
    getAuthToken().then(setAuthToken);
  }, [getAuthToken]);

  const handleUpdate = async (): Promise<void> => {
    onCardCreate();
  };

  return (
    <div css={[paddings.yb.compact]}>
      <Button
        variant="secondary"
        size="large"
        onClick={handleCreateCardModalOpen}
        data-testid="payment-add-card-btn"
        startIcon="AddPlus"
        style={cardCount > 0 ? {} : { width: 220, height: 146 }}
        aria-haspopup="dialog"
      >
        {tt('Add new card')}
      </Button>

      {showCreateCardModal && (
        <CreateCard
          authToken={authToken}
          onClose={handleCreateCardModalClose}
          userOrgId={userOrgId}
          onUpdate={handleUpdate}
        />
      )}
    </div>
  );
};

export default AddCardOption;
